<script setup lang="ts">
import type { CookieApp } from '../types/cookies';
import Copyright from './Copyright.vue';

const props = defineProps<{
	app?: CookieApp;
}>();
</script>

<template>
	<div class="backdrop">
		<div class="backdrop__media">
			<img
				class="backdrop__image"
				src="../assets/images/entry/no-backdrop.png"
				aria-hidden="true"
				role="presentation"
			/>
		</div>
		<div class="backdrop__footer">
			<Copyright :app="props.app" has-help />
			<!-- <div class="backdrop__author">
				<span class="backdrop__label">Artwork by John Doe</span>
				<HmButtonLink
					label="Learn more"
					icon="arrow-square-out"
					size="sm"
				/>
			</div> -->
		</div>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.backdrop
	{
		display:none;
		position:absolute;
		inset:0;
		z-index:-1;

		@include responsive(md)
		{
			@include flex(end);
			flex-direction:column;
		}

		&__media
		{
			position:absolute;
			inset:0;

			@include responsive(4xl)
			{
				aspect-ratio:16/9;
				width:100%;
				max-width:256rem;
				max-height:144rem;
				border-radius:var(--radius-3xl);
				box-shadow:var(--shadow-2xl);
				overflow:hidden;
				inset:50% auto auto 50%;
				translate:-50% -50%;
			}
		}
		&__image
		{
			@include size(100%);
			object-fit:cover;
		}
		&__footer
		{
			@include flex(between, end);
			height:20rem;
			padding:var(--spacing-2xl);
			position:relative;
			z-index:1;

			// Uncomment when we get MAR images
			//&::before
			//{
			//	content:'';
			//	height:inherit;
			//	background:linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.16) 100%);
			//	@include blur(lg);
			//	-webkit-mask-image:linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%);
			//	mask-image:linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 100%);
			//	-webkit-mask-repeat:no-repeat;
			//	mask-repeat:no-repeat;
			//	-webkit-mask-size:100%;
			//	mask-size:100%;
			//	-webkit-mask-position:center;
			//	mask-position:center;
			//	position:absolute;
			//	inset:0;
			//	z-index:-1;
			//}

			//@include responsive(4xl)
			//{
			//	&::before
			//	{
			//		display:none;
			//	}
			//}
		}
		//&__author
		//{
		//	@include flex(null, end, var(--spacing-4xs));
		//	flex-direction:column;
		//	text-align:end;
		//}
		//&__label
		//{
		//	color:var(--c-caption-light);
		//	text-transform:uppercase;
		//	font-size:1rem;
		//	font-weight:600;
		//}
	}
}
</style>
